import GaugeChart from "react-gauge-chart";
import { Header, Icon, Item, Message, Segment } from "semantic-ui-react";

interface Props {
  header: string;
  description: string;
  value: number | null;
  maxValue: number;
}

const DashboardGauge = ({ header, description, value, maxValue }: Props) => {
  const hasData = value !== null && value !== undefined && value > 0;
  const percent = hasData ? Math.min(maxValue, value!) / maxValue : 0;
  const formattedValue = hasData ? value!.toFixed(2) : null;

  return (
    <Segment basic textAlign="center">
      <Header textAlign="center">{header}</Header>
      {hasData ? (
        <>
          <GaugeChart
            id="inprogress-duration-gauge-chart"
            nrOfLevels={100}
            arcsLength={[0.33, 0.33, 0.33]}
            colors={["#5BE12C", "#F5CD19", "#EA4228"]}
            percent={percent}
            arcPadding={0.02}
            fontSize="16"
            textColor="#555"
            formatTextValue={() => formattedValue + " h"}
          />
          <Item>
            <Item.Content>
              <Item.Extra>{description}</Item.Extra>
            </Item.Content>
          </Item>
        </>
      ) : (
        <Message icon info>
          <Icon name="info circle" />
          <Message.Content>No data available for the selected period.</Message.Content>
        </Message>
      )}
    </Segment>
  );
};

export default DashboardGauge;
